import { render, staticRenderFns } from "./MonitoramentoModal.vue?vue&type=template&id=b8199384&scoped=true&lang=pug"
import script from "./MonitoramentoModal.vue?vue&type=script&lang=js"
export * from "./MonitoramentoModal.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoModal.vue?vue&type=style&index=0&id=b8199384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8199384",
  null
  
)

export default component.exports